import React, { useState, useEffect, useContext } from "react";

import { NavLink, useNavigate } from "react-router-dom";
import Input from "../../common/form_elements/input";
import { signUp } from "../../shared/utils/auth";
import { notify } from "../../shared/utils/helpers";
import { emailChecker, passwordChecker } from "../../shared/utils/helpers";
import { Helmet } from "react-helmet";
import UserContext from "../../shared/utils/userContext";
import translate from "../../shared/utils/translations";
import Swal from "sweetalert2";

const Register = ({ setPage }) => {
  useEffect(() => {
    setPage("auth");
    currentLanguage(localStorage.getItem("lang") || "EN");
  });
  let navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const loggedInUser = useContext(UserContext);
  const [currentLang, currentLanguage] = useState({});

  const submit = async () => {
    if (
      !formData.password ||
      !formData.renewPassword ||
      !formData.email ||
      !formData.firstname ||
      !formData.lastname
    ) {
      setErrorMessage(translate("Please fill all fields!"));
      return;
    }
    if (formData.password !== formData.renewPassword) {
      setErrorMessage(translate("Passwords do not match!"));
      return;
    }
    if (formData.password.length < 8) {
      setErrorMessage(
        translate("Password must be at least 8 characters long!")
      );
      return;
    }
    //password must contain at least one number
    if (!/\d/.test(formData.password)) {
      setErrorMessage(translate("Password must contain at least one number!"));
      return;
    }
    //password must contain at least one letter
    if (!/[a-zA-Z]/.test(formData.password)) {
      setErrorMessage(translate("Password must contain at least one letter!"));
      return;
    }
    if (formData.phone && formData.phone.length < 10) {
      setErrorMessage(
        translate("Phone number must be at least 10 characters long!")
      );
      return;
    }
    setBtnLoading(true);
    const emailCheckerResult = emailChecker(formData.email);
    const passwordCheckerResult = passwordChecker(
      formData.password,
      formData.renewPassword
    );
    if (emailCheckerResult !== true) {
      setErrorMessage(emailCheckerResult);
      return;
    }
    if (passwordCheckerResult !== true) {
      setErrorMessage(passwordCheckerResult);
      return;
    }
    if (emailCheckerResult && passwordCheckerResult) {
      const user = await signUp(
        formData.email,
        formData.password,
        formData.email,
        formData.firstname,
        formData.lastname,
        formData.affiliate_code,
        formData.phone
      );
      if (user) {
        notify(
          translate("Please check your email for verification!"),
          "success"
        );
        setBtnLoading(false);
        console.log(user);

        Swal.fire({
          iconHtml: '<img class="msg___icnn" src="/assets/img/message.svg">',
          allowOutsideClick: false,
          title: translate("Please verify your email!"),
          text: translate(
            "You're almost there! We sent an verification email to the email address you registered with. If you don't see it, you may need to check your spam folder."
          ),
          confirmButtonText: translate("Go to Login page"),
          cancelButtonText: translate("Problem? Let's start again."),
          showCancelButton: true,
          customClass: {
            container: "msg___cnt",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/login");
          } else {
            window.location.reload(false);
          }
        });
      } else {
        setErrorMessage(translate("Something went wrong, please try again!"));
        setBtnLoading(false);
      }
    }
  };
  const onChange = (e, name) => {
    setFormData({ ...formData, [name]: e });
  };

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  useEffect(() => {
    console.log(loggedInUser);
    if (loggedInUser) {
      if (loggedInUser?.role === "admin") {
        navigate("/admin-dashboard");
      } else {
        navigate("/client-dashboard");
      }
    }
  }, [loggedInUser]);

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo(0, 0);
    };

    window.addEventListener("load", handleScrollToTop);

    return () => window.removeEventListener("load", handleScrollToTop);
  }, []);

  return (
    <>
      <Helmet>
        <title>{translate("Sign up")}</title>
        <meta
          name="description"
          content={translate(
            "Don’t have an account? Our extension is designed for everyone. From beginners to advanced. No need to be an expert to get more earnings."
          )}
        />
      </Helmet>
      <div className="outer__inner auth">
        <div className="login">
          <div className="login__col bgb d_none"></div>
          <div className="login__col regstr">
            <NavLink className="login__logo" to="/home">
              <img src="/assets/img/logo-dark4.png" alt="" />
              <img src="/assets/img/logo-dark4.png" alt="" />
            </NavLink>
            <div className="login__head">
              {translate("Already have an account?")}
              <NavLink className="login__link" to="/login">
                {translate("Login")}
              </NavLink>
            </div>
            <div className="login__wrap">
              <div className="registration">
                <div className="registration__form">
                  <div className="registration__top">
                    <h3 className="registration__title h3">
                      {translate("Sign up")}
                    </h3>
                    {/* <div className="registration__info">Use Your OpenID to Sign up</div>
                    <div className="registration__btns">
                      <button className="button registration__button">
                        <svg className="icon app icon-google">
                          <use xlinkHref="#icon-google"></use>
                        </svg>
                        <span>Google</span>
                      </button>
                      <button className="button-black registration__button">
                        <svg className="icon app icon-apple">
                          <use xlinkHref="#icon-apple"></use>
                        </svg>
                        <span>Apple</span>
                      </button>
                    </div> */}
                  </div>
                  {/* <div className="registration__info">Or continue with email</div> */}
                  <div className="registration__fieldset">
                    <div className="flex_inps">
                      <Input
                        id="firstname"
                        name="firstname"
                        label={translate("First Name")}
                        type="text"
                        placeholder={translate("First Name")}
                        onChange={onChange}
                      />
                      <Input
                        id="lastname"
                        name="lastname"
                        label={translate("Last Name")}
                        type="text"
                        placeholder={translate("Last Name")}
                        onChange={onChange}
                      />
                    </div>
                    <Input
                      id="email"
                      name="email"
                      label="Email"
                      type="email"
                      placeholder="Email address"
                      onChange={onChange}
                    />
                    <Input
                      id="phone"
                      name="phone"
                      label={translate("Phone")}
                      type="tel"
                      placeholder={translate("Phone")}
                      onChange={onChange}
                    />
                    <Input
                      id="new-password"
                      name="password"
                      label={translate("Password")}
                      type="password"
                      placeholder={translate("Enter your password")}
                      isPass={true}
                      onChange={onChange}
                    />
                    <Input
                      id="renew-password"
                      name="renewPassword"
                      label={translate("Repeat New Password")}
                      type="password"
                      onChange={onChange}
                      placeholder={translate("Repeat your new password")}
                    />
                    <Input
                      id="affiliate"
                      name="affiliate_code"
                      label="Affiliate Code"
                      type="text"
                      placeholder="Affiliate Code"
                      onChange={onChange}
                    />

                    {errorMessage && (
                      <p className="entry__error">{errorMessage}</p>
                    )}
                    <div className="registration__info">
                      {currentLang === "TR" ? (
                        <>
                          Giriş yaparak veya kaydolarak 18 yaşndan büyük
                          olduğunu ve{" "}
                          <NavLink
                            className="checkbox__link"
                            to="/privacy-policy"
                          >
                            {translate("Privacy Policy")}
                          </NavLink>{" "}
                          kabul etmiş olursun
                        </>
                      ) : currentLang === "DE" ? (
                        <>
                          Mit der Anmeldung stimme ich der{" "}
                          <NavLink
                            className="checkbox__link"
                            to="/privacy-policy"
                          >
                            {translate("Privacy Policy")}
                          </NavLink>{" "}
                          zu, dass ich mindestens 18 Jahre alt bin
                        </>
                      ) : (
                        <>
                          By signing up I agree that I’m 18 years of age or
                          older, to the{" "}
                          <NavLink
                            className="checkbox__link"
                            to="/privacy-policy"
                          >
                            {translate("Privacy Policy")}
                          </NavLink>
                        </>
                      )}
                      .
                    </div>
                  </div>
                  <button
                    className="button registration__button cursorp"
                    onClick={submit}
                  >
                    {translate("Sign up")}{" "}
                    {isBtnLoading && <span className="btn-spinner"></span>}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <img
            alt="auth-world-screen"
            src="https://partners.poweredbypercent.com/13c4f10f45b00276.png"
            className="AuthBackground_image__IINQD"
          ></img>
        </div>
      </div>
    </>
  );
};

export default Register;
